import React, { useState } from 'react';
import styles from './MeasurementsAllClients.module.css';

export default function MeasurementsAllClients(clientsMeasurements, group_id) {
  // Відбрирає статистику групи в якій находимось
  const getGroupMeasurements = (measurements) => {
    const groupMeasurements = measurements.filter((item) => {
      return item.group_id === group_id;
    });
    return groupMeasurements;
  };
  // Вираховує результат схуднення від середньої ваги і середніх заміри усіх клієнтів
  const calculationAllClients = (clientsMeasurements) => {
    // Результати вирахування середньої ваги
    let calculationKg = { fullNames: [], count: 0, sumValue: 0, result: null };
    // Результати вирахування середніх замірів
    let calculationMeasurements = { fullNames: [], count: 0, sumValue: 0, result: null };

    clientsMeasurements.forEach((item, index) => {
      // Відбирає заміри групи в якій находимось
      const measurements = getGroupMeasurements(item.measurements);

      if (measurements.length && measurements.length >= 4) {
        if (!Number.isNaN(measurements[0].kg - measurements[measurements.length - 1].kg)) {
          calculationKg.fullNames.push(clientsMeasurements[index].fullName);
          calculationKg.count++;
          calculationKg.sumValue += measurements[0].kg - measurements[measurements.length - 1].kg;
        }
        // -----------
        if (
          !Number.isNaN(
            measurements[0].totalVolume - measurements[measurements.length - 1].totalVolume,
          )
        ) {
          calculationMeasurements.fullNames.push(clientsMeasurements[index].fullName);
          calculationMeasurements.count++;
          calculationMeasurements.sumValue +=
            measurements[0].totalVolume - measurements[measurements.length - 1].totalVolume;
        }
        // -----------
      }
    });

    const calculationKgResult = calculationKg.sumValue / calculationKg.count;
    const calculationMeasurementsResult =
      calculationMeasurements.sumValue / calculationMeasurements.count;

    calculationKg.result = Number.isInteger(calculationKgResult)
      ? calculationKgResult
      : calculationKgResult.toFixed(1);

    calculationMeasurements.result = Number.isInteger(calculationMeasurementsResult)
      ? calculationMeasurementsResult
      : calculationMeasurementsResult.toFixed(1);

    calculationKg.sumValue = Number.isInteger(calculationKg.sumValue)
      ? calculationKg.sumValue
      : calculationKg.sumValue.toFixed(1);

    calculationMeasurements.sumValue = Number.isInteger(calculationMeasurements.sumValue)
      ? calculationMeasurements.sumValue
      : calculationMeasurements.sumValue.toFixed(1);

    return {
      calculationKg,
      calculationMeasurements,
    };
  };
  // Рендерить результат зміни ваги і замірів за весь час
  const renderReport = ({ calculationKg, calculationMeasurements }) => {
    return (
      <div className={styles.report_wrapper}>
        <h3>Cередній результат ваги і об'ємів.</h3>
        <br />
        <div>
          <h3>Підрахунок "Ваги"</h3>
          <div>
            Кількість клієнтів: <span>{calculationKg.count} </span>
          </div>
          <div>
            Сума результатів ваги:{' '}
            <span>
              {calculationKg.sumValue >= 0
                ? '-' + calculationKg.sumValue + ' кг'
                : calculationKg.sumValue !== 'NaN'
                ? '+' + Math.abs(calculationKg.sumValue) + ' кг'
                : '-'}
            </span>
          </div>
          <div>
            Середня вага одного клієнта:{' '}
            <span>
              {calculationKg.result >= 0
                ? '-' + calculationKg.result + ' кг'
                : calculationKg.result !== 'NaN'
                ? '+' + Math.abs(calculationKg.result) + ' кг'
                : '-'}
            </span>
          </div>
        </div>
        <br />
        <div>
          <h3>Підрахунок "Об'ємів"</h3>

          <div>
            Кількість клієнтів: <span>{calculationMeasurements.count} </span>
          </div>
          <div>
            Сума результатів об'ємів:{' '}
            <span>
              {calculationMeasurements.sumValue >= 0
                ? '-' + calculationMeasurements.sumValue + ' см'
                : calculationMeasurements.sumValue !== 'NaN'
                ? '+' + Math.abs(calculationMeasurements.sumValue) + ' см'
                : '-'}
            </span>
          </div>
          <div>
            Середній об'єм одного клієнта:{' '}
            <span>
              {calculationMeasurements.result >= 0
                ? '-' + calculationMeasurements.result + ' см'
                : calculationMeasurements.result !== 'NaN'
                ? '+' + Math.abs(calculationMeasurements.result) + ' см'
                : '-'}
            </span>
          </div>
        </div>
        <br />
        <div>
          <h3>Як це працює?</h3>
          <p>
            Клієнти які мають 4 і більше заміри і в котрих заповнений перший і останній замір беруть
            участь в підрахунку.
          </p>
          <ol className={styles.ol_wrappe}>
            <li>В кожного клієнта від першого заміру віднімається останній.</li>
            <li>Всі отримані результати сумуються (Отримуєм общий результат)</li>
            <li>
              Общий результат ділимо на кількість клієнтів (Отримуєм середній результат одного
              клієнта)
            </li>
          </ol>
        </div>
      </div>
    );
  };

  return <>{renderReport(calculationAllClients(clientsMeasurements))}</>;
}
